import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initSentry } from './lib/sentry';
import { registerServiceWorker } from './lib/pwa';

// Sentry init runs BEFORE mounting so the SDK can install its error
// boundary integration before the React tree exists. No-op if
// VITE_SENTRY_DSN_FRONTEND is empty (dev local, tests).
initSentry();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Service worker registration en background — pas d'await pour ne pas
// retarder le premier paint. No-op si le navigateur ne supporte pas SW
// ou si on est en jsdom/test (le module virtuel 'virtual:pwa-register'
// est absent dans ces contextes).
registerServiceWorker();
